export const STYLES = {
  real: {
    fillColor: "#940909",
    fillOpacity: 0.55,
    lineColor: "#940909",
    lineWidth: 2,
    dasharray: null,
  },
  sim: {
    fillColor: "#000000",
    fillOpacity: 0,
    lineColor: "#59112B",
    lineWidth: 3,
    dasharray: [2, 2],
  },
};
export const IMPACT_LAYERS = {
  zone: {
    prop: "saved_zone", // key in the API response
    source: "impact-saved-zone",
    fill: "#738C32",
    fillOpacity: 0.7,
    line: "#738C32",
    lineWidth: 1.5,
  },
  saved: {
    prop: "saved_buildings",
    source: "impact-saved-buildings",
    fill: "#5a9713",
    fillOpacity: 0.95,
    line: "#3F6B12",
    lineWidth: 1,
    dot: "#5a9713", 
  },
  burned: {
    prop: "burned_buildings",
    source: "impact-burned-buildings",
    fill: "#D32F2F",
    fillOpacity: 0.95,
    line: "#7A0F0F",
    lineWidth: 1,
    dot: "#D32F2F", 
  },
};